module.exports = __webpack_public_path__ + "media/images/emblems/Opfikon-blazon-1351b5597f96e13df3e64415369dec3b.svg";